import { Table, message, Button, Row, Col, Pagination, Image, Space, Tag } from "antd";
import { EditOutlined, PlusOutlined, FileTextOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";

export default function BlogManage() {
  const [blog, setBlog] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchBlog = async () => {
    await axiosInstance.get(`/blog/getAllAdmin`, {params: pagination})
      .then((res) => {
        const data = res?.data;
        setBlog(data);
      })
      .catch(() => message.error("Error server!"));
  };

  useEffect(() => {
    fetchBlog();
  }, [pagination]);

  const columns = [
    {
      title: <div>ID</div>,
      key: "blog_id",
      dataIndex: "blog_id",
      width: 100,
      sorter: (a, b) => a.blog_id - b.blog_id,
      render: (_, record) => <div>{record?.blog_id}</div>,
    },
    {
      title: <div>Tên</div>,
      key: "blog_name",
      dataIndex: "blog_name",
      width: 150,
      ...SearchProps("blog_name"),
      render: (_, record) => <div>{record?.blog_name}</div>,
    },
    {
      title: <div>Slug</div>,
      key: "blog_slug",
      dataIndex: "blog_slug",
      width: 150,
      ...SearchProps("blog_slug"),
      render: (_, record) => <div>{record?.blog_slug}</div>,
    },
    {
      title: <div>Ảnh</div>,
      key: "blog_image",
      dataIndex: "blog_image",
      width: 150,
      render: (_, record) => <div><Image src={record?.blog_image} width={100} height={100}/></div>,
    },
    {
      title: <div>Danh mục Blog</div>,
      key: "category_blog_id",
      dataIndex: "category_blog_id",
      width: 150,
      ...SearchProps("category_blog_id"),
      render: (_, record) => 
        <div>
          <p>{record?.category_blog_id} </p>
          <p>{record?.category_blog_name}</p>
        </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">SEO Title</div>,
      key: "blog_title_seo",
      dataIndex: "blog_title_seo",
      width: 200,
      render: (_, record) => <div className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-gray-600 italic">
        {record?.blog_title_seo || <span className="text-gray-300 font-normal">Chưa thiết lập</span>}
      </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">SEO Description</div>,
      key: "blog_description_seo",
      dataIndex: "blog_description_seo",
      width: 250,
      render: (_, record) => <div className="max-w-[250px] overflow-hidden text-ellipsis line-clamp-2 text-gray-500 text-xs">
        {record?.blog_description_seo || <span className="text-gray-300">Nội dung SEO chưa được tối ưu hóa...</span>}
      </div>,
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">Trạng thái</div>,
      key: "blog_status",
      dataIndex: "blog_status",
      width: 120,
      render: (status) => (
        <Tag color={status === 'public' ? 'green' : 'orange'} className="rounded-full px-3 py-0.5 font-bold uppercase text-[10px]">
          {status === 'public' ? 'Công khai' : 'Bài nháp'}
        </Tag>
      ),
    },
    {
      title: <div className="text-blue-600 font-bold uppercase text-[11px]">Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 120,
      sorter: (a, b) => dayjs(a.create_at).unix() - dayjs(b.create_at).unix(),
      render: (date) => <div className="text-[13px] font-medium text-gray-500">{dayjs(date).format("DD/MM/YYYY")}</div>,
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 80,
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/admin/quan-ly-blog/${record?.blog_id}`}>
            <Button 
              type="primary" 
              ghost 
              shape="circle" 
              icon={<EditOutlined />} 
              className="hover:scale-110 transition-transform"
            />
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-6 mt-2">
        <Row align="middle" justify="space-between">
          <Col>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                 <FileTextOutlined className="text-blue-600 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-black text-gray-800 m-0 leading-tight">Quản lý Blog</h1>
                <p className="text-gray-400 text-xs m-0">Đăng tải và tối ưu bài viết chuẩn SEO Google</p>
              </div>
            </div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-blog/tao-moi"}>
              <Button type="primary" size="large" icon={<PlusOutlined />} className="rounded-xl font-bold h-11 px-8 shadow-lg shadow-blue-100">
                Viết bài mới
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={blog?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={blog?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
